const config = {
  url: '/headings',
  title: 'Рубрики',
  endpoint: '/admin-search?filter=headings',
  type: 'table',
  getUrl: id => `/heading/${id}`,
  getApiUrl: id => `/headings/${id}`,
  search: true,
  key: 'headings',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
